import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import ConfirmDialog from "../../../../components/genericform/ConfirmDialog";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { Product } from "src/shared/services/interfacev2";
import { deleteProducts } from "src/shared/services/servicesv2";

interface Props {
  product: Product;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteProducts: React.FC<Props> = ({ product, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);

  const deleteProduct = async () => {
    if (!product._id?.$oid || loading) return; // extra safety

    setLoading(true);
    try {
      await deleteProducts([product._id.$oid]);
      // await api.delete(`/app/pos/v2/product`, {
      //   data: { ids: [product._id.$oid] },
      // });
        notifySuccess("Product deleted successfully");
        onDelete();
        onClose(); // modal closes → component unmounts
      
    } catch (error) {
      console.error("Error deleting product:", error);
      notifyError("Failed to delete product.");
      setLoading(false); // ✅ only reset on error
    }
  };

  return (
    <ConfirmDialog
      open={true}
      title="Delete Confirmation"
      description={`Are you sure you want to delete the product: "${product.productName}"?`}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      isProcessing={loading}
      onConfirm={deleteProduct}
      onCancel={onClose}
    />
  );
};


export default DeleteProducts;
